"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorComponentWeb = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const errorComponentWeb = (message) => (0, jsx_runtime_1.jsx)("div", { style: { marginTop: 10 }, children: (0, jsx_runtime_1.jsx)("span", { className: "error-message", children: message }) });
exports.errorComponentWeb = errorComponentWeb;
